import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

import { DocumentLibDto } from '@app/api';

import { CerAppDocumentationLinkHelper } from './cer-app-documentation-link-helper'
import { documentTypeByExtension, fileNameExtensionGet } from '@cer/cer-form/cer-form-view-type/cer-form-view-type-document/cer-form-view-document-type';
import { DocumentLibAttachmentView } from '@core/document-lib/document-lib-attachment-view';

export class CerAppDocumentationForm extends CerFormAdapter {

  private docLib: DocumentLibDto;

  override async init(): Promise<boolean> {
    const documentLibId = this.context.session.environment.documentationLibraryId$.getValue();
    const docLibs = this.routeOptions.context.session.user.documentLibs();
    this.docLib = docLibs?.find(l => l.id == documentLibId);
    if (this.docLib == null) {
      this.context.ui.operationEndError("Dokument bibliotek er ikke tilængeligt");
      return false;
    }
    return true;
  }

  override view(): CerFormView {

    const ctx = this.context;
    const opt = this.routeOptions;
    const callerData = opt.navigation?.callerData;
    const allowEdit = this.docLib.allowEdit;

    const v = new DocumentLibAttachmentView(this.docLib, ctx);
    v.paneTarget = opt?.callerData?.paneTarget ?? opt?.navigation?.paneTarget ?? "main";
    v.titleHeaderVisible = false;
    v.viewMetadata.allowEdit = allowEdit;
    v.title = opt.navigation?.title ?? opt.title ?? "Dokumentation";

    const linkHelper = new CerAppDocumentationLinkHelper(this.context, this.docLib, v, v.paneTarget);
    v.documentFileName = callerData?.documentFileName ?? 'index.md';
    v.documentType = callerData?.documentType ?? documentTypeByExtension(fileNameExtensionGet(v.documentFileName));
    v.documentUrl = linkHelper.linkedAttachmentUrlGet(v.documentFileName);

    if (allowEdit) {
      v.documentUrlUpdate = linkHelper.linkedAttachmentUploadUrlGet('/', true, false);
    }
    return v;
  }

}
